import { allTurnTracker } from '@/pages/turn-tracker/route';
import type { RouteRecordRaw } from 'vue-router';

export const turnTrackerRoutes: RouteRecordRaw = {
  path: '/turn-tracker',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
  },
  children: [
    ...allTurnTracker,
  ],
};

